type LogoProps = {
  variant?: "sidebar" | "login";
};

export function Logo({ variant = "sidebar" }: LogoProps) {
  return (
    <div
      className={`logo-stack logo-stack--${variant}`}
      role="img"
      aria-label="Vet Guard — Billing audit for vets"
    >
      <div className="logo-mark-wrap">
        <img src="/vet-guard-logo.png" alt="" aria-hidden className="logo-mark" />
      </div>
      <p className="logo-tagline">Billing audit for vets</p>
    </div>
  );
}
